import React from "react";
import { Button, ButtonGroup, Stack, Heading } from "@shopify/polaris";

import "./saveBar.scss";

export default function SaveBar({ show, cancelClick, saveClick, saveLoading }) {
  return (
    <>
      {show && (
        <div className="autoketing_save_bar">
          <Stack alignment="center">
            <Stack.Item fill>
              <Heading>Unsaved changes</Heading>
            </Stack.Item>
            <Stack.Item>
              <ButtonGroup>
                <Button onClick={cancelClick}>Cancel</Button>
                <Button loading={saveLoading} primary onClick={saveClick}>
                  Save
                </Button>
              </ButtonGroup>
            </Stack.Item>
          </Stack>
        </div>
      )}
    </>
  );
}
